import type { RouteObject } from 'react-router-dom';
import { RequirePermission } from '../auth/guards';
import { CoverageCheckPage } from '../enrollments/CoverageCheckPage';
import { LifelineListPage, LifelineSearchPage, LifelineStatusPage } from './LifelineListPages';
import { LifelineApplicationPage, LifelineNewPage } from './LifelineWizardPage';

const guard = (code: string, element: JSX.Element) => (
  <RequirePermission code={code}>{element}</RequirePermission>
);

/** Lifeline (PC1164 to PC1168) routes, mounted under the app shell. */
export const lifelineRoutes: RouteObject[] = [
  { path: 'lifeline/new', element: guard('PC1164', <LifelineNewPage />) },
  { path: 'lifeline/search', element: guard('PC1165', <LifelineSearchPage />) },
  { path: 'lifeline/status', element: guard('PC1165', <LifelineStatusPage />) },
  {
    path: 'lifeline/coverage-check',
    element: guard('PC816', <CoverageCheckPage key="lifeline" program="lifeline" />),
  },
  // `key` gives each list its own filters and page, although they share one component.
  { path: 'lifeline', element: guard('PC1165', <LifelineListPage key="all" mode="all" />) },
  {
    path: 'lifeline/completed',
    element: guard('PC1166', <LifelineListPage key="completed" mode="completed" />),
  },
  {
    path: 'lifeline/incomplete',
    element: guard('PC1167', <LifelineListPage key="incomplete" mode="incomplete" />),
  },
  {
    path: 'lifeline/rejected',
    element: guard('PC1168', <LifelineListPage key="rejected" mode="rejected" />),
  },
  { path: 'lifeline/:id', element: guard('PC1164', <LifelineApplicationPage />) },
];
